import React, { FunctionComponent, ReactElement, memo } from 'react'
import BasicTextButton from '../Basic'
import { TextButtonProps } from '../type'

const SmallTextButton: FunctionComponent<TextButtonProps> = ({
    children,
    color = 'onyx',
    href,
    onPress,
    expand,
    testID,
}): ReactElement => {
    return (
        <BasicTextButton height={32} paddingX={5} {...{ color, href, onPress, expand, testID }}>
            {children}
        </BasicTextButton>
    )
}

export default memo(SmallTextButton)
